export enum UserRole {
  User,
  Admin,
  Report
}
